import { CSSProperties } from "react";

import { UploadOutlinedIcon } from "icons";
import { colors } from "theme/palette";

import Button from "components/Button";
import { DropzoneState } from "components/Dropzone";
import Paper from "components/Paper";
import Stack from "components/Stack";
import Text from "components/Text";

export interface IDealImportFileUploadButton {
  state: Partial<DropzoneState>;
  sx?: CSSProperties;
}

export const DealImportFileUploadButton = ({
  state,
  sx,
}: IDealImportFileUploadButton) => {
  return (
    <Paper
      sx={{
        border: `2px dashed ${
          state.isDragActive ? colors.pink100 : colors.gray40
        }`,
        height: "100%",
        cursor: "pointer",
        display: "flex",
        justifyContent: "center",
        color: state.isDragActive ? colors.gray60 : colors.black,
        ...sx,
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        spacing={1}
        flexDirection="column"
        gap={1}
      >
        <UploadOutlinedIcon
          sx={{ height: "80px", width: "80px", color: colors.gray60 }}
        />
        <Text variant="h2" color={colors.gray60} fontWeight={700}>
          Drag & drop
        </Text>
        <Button variant="outlined" sx={{ color: colors.black }}>
          Browse files
        </Button>
      </Stack>
    </Paper>
  );
};
